/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoWalletTransactionLogListWalletTransactionLogData model module.
 * @module model/LogControllerDtoWalletTransactionLogListWalletTransactionLogData
 * @version 1.0
 */
class LogControllerDtoWalletTransactionLogListWalletTransactionLogData {
    /**
     * Constructs a new <code>LogControllerDtoWalletTransactionLogListWalletTransactionLogData</code>.
     * @alias module:model/LogControllerDtoWalletTransactionLogListWalletTransactionLogData
     */
    constructor() { 
        
        LogControllerDtoWalletTransactionLogListWalletTransactionLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoWalletTransactionLogListWalletTransactionLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoWalletTransactionLogListWalletTransactionLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoWalletTransactionLogListWalletTransactionLogData} The populated <code>LogControllerDtoWalletTransactionLogListWalletTransactionLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoWalletTransactionLogListWalletTransactionLogData();

            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('walletNo')) {
                obj['walletNo'] = ApiClient.convertToType(data['walletNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('transactionType')) {
                obj['transactionType'] = ApiClient.convertToType(data['transactionType'], 'Number');
            }
            if (data.hasOwnProperty('per')) {
                obj['per'] = ApiClient.convertToType(data['per'], 'Number');
            }
            if (data.hasOwnProperty('xper')) {
                obj['xper'] = ApiClient.convertToType(data['xper'], 'Number');
            }
            if (data.hasOwnProperty('hvh')) {
                obj['hvh'] = ApiClient.convertToType(data['hvh'], 'Number');
            }
            if (data.hasOwnProperty('usdt')) {
                obj['usdt'] = ApiClient.convertToType(data['usdt'], 'Number');
            }
            if (data.hasOwnProperty('arb')) {
                obj['arb'] = ApiClient.convertToType(data['arb'], 'Number');
            }
            if (data.hasOwnProperty('beforePer')) {
                obj['beforePer'] = ApiClient.convertToType(data['beforePer'], 'Number');
            }
            if (data.hasOwnProperty('beforeXper')) {
                obj['beforeXper'] = ApiClient.convertToType(data['beforeXper'], 'Number');
            }
            if (data.hasOwnProperty('beforeHvh')) {
                obj['beforeHvh'] = ApiClient.convertToType(data['beforeHvh'], 'Number');
            }
            if (data.hasOwnProperty('beforeUsdt')) {
                obj['beforeUsdt'] = ApiClient.convertToType(data['beforeUsdt'], 'Number');
            }
            if (data.hasOwnProperty('beforeArb')) {
                obj['beforeArb'] = ApiClient.convertToType(data['beforeArb'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('internalTransactionType')) {
                obj['internalTransactionType'] = ApiClient.convertToType(data['internalTransactionType'], 'Number');
            }
            if (data.hasOwnProperty('transactionLog')) {
                obj['transactionLog'] = ApiClient.convertToType(data['transactionLog'], 'String');
            }
            if (data.hasOwnProperty('accountSessionNo')) {
                obj['accountSessionNo'] = ApiClient.convertToType(data['accountSessionNo'], 'Number');
            }
            if (data.hasOwnProperty('gameSessionNo')) {
                obj['gameSessionNo'] = ApiClient.convertToType(data['gameSessionNo'], 'Number');
            }
            if (data.hasOwnProperty('targetWalletNo')) {
                obj['targetWalletNo'] = ApiClient.convertToType(data['targetWalletNo'], 'Number');
            }
            if (data.hasOwnProperty('targetPer')) {
                obj['targetPer'] = ApiClient.convertToType(data['targetPer'], 'Number');
            }
            if (data.hasOwnProperty('targetXper')) {
                obj['targetXper'] = ApiClient.convertToType(data['targetXper'], 'Number');
            }
            if (data.hasOwnProperty('targetHvh')) {
                obj['targetHvh'] = ApiClient.convertToType(data['targetHvh'], 'Number');
            }
            if (data.hasOwnProperty('targetUsdt')) {
                obj['targetUsdt'] = ApiClient.convertToType(data['targetUsdt'], 'Number');
            }
            if (data.hasOwnProperty('targetArb')) {
                obj['targetArb'] = ApiClient.convertToType(data['targetArb'], 'Number');
            }
            if (data.hasOwnProperty('targetBeforePer')) {
                obj['targetBeforePer'] = ApiClient.convertToType(data['targetBeforePer'], 'Number');
            }
            if (data.hasOwnProperty('targetBeforeXper')) {
                obj['targetBeforeXper'] = ApiClient.convertToType(data['targetBeforeXper'], 'Number');
            }
            if (data.hasOwnProperty('targetBeforeHvh')) {
                obj['targetBeforeHvh'] = ApiClient.convertToType(data['targetBeforeHvh'], 'Number');
            }
            if (data.hasOwnProperty('targetBeforeUsdt')) {
                obj['targetBeforeUsdt'] = ApiClient.convertToType(data['targetBeforeUsdt'], 'Number');
            }
            if (data.hasOwnProperty('targetBeforeArb')) {
                obj['targetBeforeArb'] = ApiClient.convertToType(data['targetBeforeArb'], 'Number');
            }
            if (data.hasOwnProperty('onchainTxid')) {
                obj['onchainTxid'] = ApiClient.convertToType(data['onchainTxid'], 'String');
            }
            if (data.hasOwnProperty('feeWalletTransactionNo')) {
                obj['feeWalletTransactionNo'] = ApiClient.convertToType(data['feeWalletTransactionNo'], 'Number');
            }
            if (data.hasOwnProperty('feeWalletNo')) {
                obj['feeWalletNo'] = ApiClient.convertToType(data['feeWalletNo'], 'Number');
            }
            if (data.hasOwnProperty('feePer')) {
                obj['feePer'] = ApiClient.convertToType(data['feePer'], 'Number');
            }
            if (data.hasOwnProperty('feeXper')) {
                obj['feeXper'] = ApiClient.convertToType(data['feeXper'], 'Number');
            }
            if (data.hasOwnProperty('feeHvh')) {
                obj['feeHvh'] = ApiClient.convertToType(data['feeHvh'], 'Number');
            }
            if (data.hasOwnProperty('feeUsdt')) {
                obj['feeUsdt'] = ApiClient.convertToType(data['feeUsdt'], 'Number');
            }
            if (data.hasOwnProperty('feeArb')) {
                obj['feeArb'] = ApiClient.convertToType(data['feeArb'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoWalletTransactionLogListWalletTransactionLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoWalletTransactionLogListWalletTransactionLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['transactionLog'] && !(typeof data['transactionLog'] === 'string' || data['transactionLog'] instanceof String)) {
            throw new Error("Expected the field `transactionLog` to be a primitive type in the JSON string but got " + data['transactionLog']);
        }
        // ensure the json data is a string
        if (data['onchainTxid'] && !(typeof data['onchainTxid'] === 'string' || data['onchainTxid'] instanceof String)) {
            throw new Error("Expected the field `onchainTxid` to be a primitive type in the JSON string but got " + data['onchainTxid']);
        }

        return true;
    }


}



/**
 * @member {Number} transactionNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} walletNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['walletNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['email'] = undefined;

/**
 * @member {Number} transactionType
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['transactionType'] = undefined;

/**
 * @member {Number} per
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['per'] = undefined;

/**
 * @member {Number} xper
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['xper'] = undefined;

/**
 * @member {Number} hvh
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['hvh'] = undefined;

/**
 * @member {Number} usdt
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['usdt'] = undefined;

/**
 * @member {Number} arb
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['arb'] = undefined;

/**
 * @member {Number} beforePer
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['beforePer'] = undefined;

/**
 * @member {Number} beforeXper
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['beforeXper'] = undefined;

/**
 * @member {Number} beforeHvh
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['beforeHvh'] = undefined;

/**
 * @member {Number} beforeUsdt
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['beforeUsdt'] = undefined;

/**
 * @member {Number} beforeArb
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['beforeArb'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['createdAt'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['status'] = undefined;

/**
 * @member {Number} internalTransactionType
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['internalTransactionType'] = undefined;

/**
 * @member {String} transactionLog
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['transactionLog'] = undefined;

/**
 * @member {Number} accountSessionNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['accountSessionNo'] = undefined;

/**
 * @member {Number} gameSessionNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['gameSessionNo'] = undefined;

/**
 * @member {Number} targetWalletNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetWalletNo'] = undefined;

/**
 * @member {Number} targetPer
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetPer'] = undefined;

/**
 * @member {Number} targetXper
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetXper'] = undefined;

/**
 * @member {Number} targetHvh
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetHvh'] = undefined;

/**
 * @member {Number} targetUsdt
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetUsdt'] = undefined;

/**
 * @member {Number} targetArb
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetArb'] = undefined;

/**
 * @member {Number} targetBeforePer
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetBeforePer'] = undefined;

/**
 * @member {Number} targetBeforeXper
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetBeforeXper'] = undefined;

/**
 * @member {Number} targetBeforeHvh
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetBeforeHvh'] = undefined;

/**
 * @member {Number} targetBeforeUsdt
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetBeforeUsdt'] = undefined;

/**
 * @member {Number} targetBeforeArb
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['targetBeforeArb'] = undefined;

/**
 * @member {String} onchainTxid
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['onchainTxid'] = undefined;

/**
 * @member {Number} feeWalletTransactionNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['feeWalletTransactionNo'] = undefined;

/**
 * @member {Number} feeWalletNo
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['feeWalletNo'] = undefined;

/**
 * @member {Number} feePer
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['feePer'] = undefined;

/**
 * @member {Number} feeXper
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['feeXper'] = undefined;

/**
 * @member {Number} feeHvh
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['feeHvh'] = undefined;

/**
 * @member {Number} feeUsdt
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['feeUsdt'] = undefined;

/**
 * @member {Number} feeArb
 */
LogControllerDtoWalletTransactionLogListWalletTransactionLogData.prototype['feeArb'] = undefined;






export default LogControllerDtoWalletTransactionLogListWalletTransactionLogData;

